(() => {
  if (window.__lmcdElvasmaScript) return;
  window.__lmcdElvasmaScript = true;

  const initializeRoot = (root) => {
    if (root.dataset.elvasmaReady === 'true') return;
    root.dataset.elvasmaReady = 'true';
    const cleanup = [];
    const all = (selector) => [...root.querySelectorAll(selector)];
    const one = (selector) => root.querySelector(selector);
    const listen = (target, event, handler, options) => {
      target?.addEventListener(event, handler, options);
      cleanup.push(() => target?.removeEventListener?.(event, handler, options));
    };

    const gallery = one('[data-elvasma-gallery]');
    const main = one('[data-elvasma-main]');
    const thumbnails = all('[data-elvasma-gallery-image]');
    let activeImage = 0;
    const showImage = (index) => {
      if (!thumbnails.length) return;
      activeImage = (index + thumbnails.length) % thumbnails.length;
      const image = thumbnails[activeImage];
      if (main && image) main.src = image.dataset.image;
      gallery?.setAttribute('data-active-index', String(activeImage));
      thumbnails.forEach((thumbnail, thumbnailIndex) => thumbnail.classList.toggle('elvProduct_activeThumbnail', thumbnailIndex === activeImage));
    };
    thumbnails.forEach((thumbnail, index) => listen(thumbnail, 'click', () => showImage(index)));
    listen(one('[data-elvasma-gallery-prev]'), 'click', () => showImage(activeImage - 1));
    listen(one('[data-elvasma-gallery-next]'), 'click', () => showImage(activeImage + 1));

    const backdrop = one('[data-elvasma-drawer-backdrop]');
    const menu = one('[data-elvasma-menu-drawer]');
    const cart = one('[data-elvasma-cart-drawer]');
    const closeDrawers = () => {
      [menu, cart].forEach((drawer) => { drawer?.classList.remove('elvTop_drawerOpen'); drawer?.setAttribute('aria-hidden', 'true'); });
      backdrop?.classList.remove('elvTop_drawerBackdropOpen');
    };
    const openDrawer = (drawer) => {
      closeDrawers();
      drawer?.classList.add('elvTop_drawerOpen');
      drawer?.setAttribute('aria-hidden', 'false');
      backdrop?.classList.add('elvTop_drawerBackdropOpen');
    };
    listen(one('[data-elvasma-menu-open]'), 'click', () => openDrawer(menu));
    listen(one('[data-elvasma-cart-open]'), 'click', () => openDrawer(cart));
    all('[data-elvasma-drawer-close]').forEach((button) => listen(button, 'click', closeDrawers));
    listen(backdrop, 'click', closeDrawers);

    const timer = one('[data-elvasma-countdown]');
    if (timer) {
      const values = all('[data-elvasma-countdown] .elvTop_countdownValue');
      let secondsLeft = 3 * 3600 + 37 * 60 + 52;
      const tick = () => {
        const valuesByUnit = [Math.floor(secondsLeft / 3600), Math.floor(secondsLeft % 3600 / 60), secondsLeft % 60];
        values.forEach((value, index) => { value.textContent = String(valuesByUnit[index]).padStart(2, '0'); });
        secondsLeft = Math.max(0, secondsLeft - 1);
      };
      tick();
      const countdown = window.setInterval(tick, 1000);
      cleanup.push(() => window.clearInterval(countdown));
    }

    const videos = all('[data-elvasma-video] video');
    const pauseSiblings = (activeVideo) => videos.forEach((video) => {
      if (video !== activeVideo) video.pause();
    });
    videos.forEach((video) => {
      const frame = video.closest('[data-elvasma-video]');
      const soundButton = frame?.querySelector('[data-elvasma-video-sound]');
      const updateSoundButton = () => {
        const isAudible = !video.muted && video.volume > 0;
        soundButton?.setAttribute('aria-pressed', String(isAudible));
        if (soundButton) soundButton.textContent = isAudible ? 'Mute sound' : 'Tap for sound';
      };
      const coordinateAudio = () => {
        if (!video.muted && video.volume > 0) pauseSiblings(video);
        updateSoundButton();
      };
      listen(video, 'play', () => {
        frame?.classList.add('elvEditorial_videoPlaying');
        pauseSiblings(video);
      });
      listen(video, 'pause', () => frame?.classList.remove('elvEditorial_videoPlaying'));
      listen(video, 'volumechange', coordinateAudio);
      listen(soundButton, 'click', () => {
        video.muted = !video.muted;
        if (!video.muted) { pauseSiblings(video); video.play().catch(() => {}); }
        updateSoundButton();
      });
      updateSoundButton();
    });

    const panel = one('[data-elvasma-purchase-panel]');
    const sticky = one('[data-elvasma-sticky-purchase]');
    const form = one('.elvProduct_purchaseAction');
    if (panel && sticky && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(([entry]) => { sticky.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0; });
      observer.observe(panel);
      cleanup.push(() => observer.disconnect());
    }
    listen(one('[data-elvasma-sticky-submit]'), 'click', () => form?.requestSubmit?.());

    const cards = all('[data-elvasma-review-card]');
    listen(one('[data-elvasma-load-more]'), 'click', (event) => {
      cards.forEach((card) => { card.hidden = false; });
      event.currentTarget.hidden = true;
      const count = one('.elvLower_reviewToolbar span');
      if (count) count.textContent = '8 of 362 reviews';
    });
    const modal = one('[data-elvasma-review-modal]');
    const expanded = one('[data-elvasma-review-expanded]');
    all('[data-review-image]').forEach((button) => listen(button, 'click', () => {
      if (expanded) expanded.src = button.dataset.reviewImage;
      if (modal) modal.hidden = false;
    }));
    listen(one('[data-elvasma-review-close]'), 'click', () => { if (modal) modal.hidden = true; });

    const miniReviews = all('[data-elvasma-mini-review]');
    const miniCounter = one('[data-elvasma-review-counter]');
    let activeReview = 0;
    const showMiniReview = (index) => {
      if (!miniReviews.length) return;
      activeReview = (index + miniReviews.length) % miniReviews.length;
      miniReviews.forEach((review, reviewIndex) => { review.hidden = reviewIndex !== activeReview; review.dataset.active = String(reviewIndex === activeReview); });
      if (miniCounter) miniCounter.textContent = `${activeReview + 1} / ${miniReviews.length}`;
    };
    listen(one('[data-elvasma-review-prev]'), 'click', () => showMiniReview(activeReview - 1));
    listen(one('[data-elvasma-review-next]'), 'click', () => showMiniReview(activeReview + 1));

    const highlights = all('.elvLower_highlightCard');
    const highlightCounter = one('.elvLower_highlightControls span');
    let activeHighlight = 0;
    const showHighlight = (index) => {
      if (!highlights.length) return;
      activeHighlight = (index + highlights.length) % highlights.length;
      highlights.forEach((highlight, highlightIndex) => { highlight.dataset.active = String(highlightIndex === activeHighlight); });
      if (highlightCounter) highlightCounter.textContent = `${activeHighlight + 1} of ${highlights.length}`;
    };
    listen(one('[data-elvasma-highlight-prev]'), 'click', () => showHighlight(activeHighlight - 1));
    listen(one('[data-elvasma-highlight-next]'), 'click', () => showHighlight(activeHighlight + 1));

    listen(document, 'keydown', (event) => {
      if (event.key !== 'Escape') return;
      closeDrawers();
      if (modal) modal.hidden = true;
    });
    root.__lmcdElvasmaTeardown = () => {
      videos.forEach((video) => { video.pause(); video.muted = true; });
      cleanup.splice(0).forEach((remove) => remove());
      delete root.dataset.elvasmaReady;
    };
  };

  const initializeAll = () => document.querySelectorAll('.lmcd-elvasma[data-lmcd-house-offer]').forEach(initializeRoot);
  const destroyWithin = (node) => {
    if (node.matches?.('.lmcd-elvasma[data-lmcd-house-offer]')) node.__lmcdElvasmaTeardown?.();
    node.querySelectorAll?.('.lmcd-elvasma[data-lmcd-house-offer]').forEach((root) => root.__lmcdElvasmaTeardown?.());
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
  else initializeAll();
  document.addEventListener('shopify:section:load', initializeAll);
  document.addEventListener('shopify:section:unload', (event) => destroyWithin(event.target));
})();
